/* eslint-disable react/no-array-index-key */
import React from 'react';
import styles from './ReleaseDonator.module.css';
import { Image, standards } from '../../../../../components';

export default function ReleaseDonator(props) {
  const { commands, sharedStates } = props;

  return (
    <section className={styles.container}>
      <div className={styles.identification}>
        <div className={styles.image}>
          <Image
            src={sharedStates.userImage}
            alt={`Foto de ${sharedStates.firstName} ${sharedStates.lastName}`}
            rounded
            circledColor={standards.colors.orange.strong}
            bottomShadow
          />
        </div>
        <p className={styles.name}>{sharedStates.firstName} {sharedStates.lastName}</p>
        <p className={styles.identifier}>Solidário Locall</p>
      </div>
      <div className={styles.messageBox}>
        <p className={styles.gratefulnes}>
          {sharedStates.firstName}, muito obrigado por ajudar a construir um mundo melhor sendo um
          {' '}
          <span className={styles.identifierText}>Solidário Locall</span>
          . Sua doação é crucial para levar este ideal de bem comum para mais pessoas!
          {/* {' '} */}
          {/* <span className={styles.identifierText}>Saiba mais</span> */}
          .
        </p>
        <p className={styles.message}>
          O espaço
          {' '}
          <span className={styles.spaceName}>{sharedStates.space.name}</span>
          {' '}
          foi notificado e a fatura chegará automaticamente no seu e-mail nos próximos minutos.
        </p>
      </div>
    </section>
  );
}
